import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  schema?: Record<string, unknown>;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  schema,
}: SEOHeadProps) {
  const location = useLocation();

  const defaultTitle = '韩漫在线观看 - 漫画免费下拉式 - 好看的韩国漫画全集 - 韩漫网站';
  const defaultDescription = '韩漫在线观看，免费下拉式漫画阅读平台。提供韩国漫画全集在线阅读，高清画质和流畅阅读体验。收录恋爱、奇幻、动作、剧情、喜剧、悬疑等热门韩漫，随时随地畅读您喜爱的作品。';
  const defaultKeywords = '韩漫在线观看,免费下拉式漫画,韩国漫画全集,韩漫网站';

  const pageTitle = title ? `${title} - 韩漫在线` : defaultTitle;
  const pageDescription = description || defaultDescription;
  const pageKeywords = keywords || defaultKeywords;
  const pageCanonical = canonicalUrl || `http://wxctif.com/${location.pathname}`;

  useEffect(() => {
    document.title = pageTitle;

    const metaTags: Record<string, string> = {
      description: pageDescription,
      keywords: pageKeywords,
    };

    Object.entries(metaTags).forEach(([name, content]) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    });

    const ogTags: Record<string, string> = {
      'og:title': pageTitle,
      'og:description': pageDescription,
      'og:type': ogType,
      'og:url': pageCanonical,
      'og:site_name': '韩漫在线',
      'og:locale': 'zh_CN',
      'twitter:card': 'summary_large_image',
      'twitter:title': pageTitle,
      'twitter:description': pageDescription,
    };

    Object.entries(ogTags).forEach(([property, content]) => {
      let el = document.querySelector(`meta[property="${property}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('property', property);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    });

    let canonicalEl = document.querySelector('link[rel="canonical"]');
    if (!canonicalEl) {
      canonicalEl = document.createElement('link');
      canonicalEl.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalEl);
    }
    canonicalEl.setAttribute('href', pageCanonical);
  }, [pageTitle, pageDescription, pageKeywords, pageCanonical, ogType]);

  useEffect(() => {
    if (schema) {
      const scriptId = 'schema-jsonld';
      let scriptEl = document.getElementById(scriptId) as HTMLScriptElement | null;
      if (!scriptEl) {
        scriptEl = document.createElement('script');
        scriptEl.id = scriptId;
        scriptEl.type = 'application/ld+json';
        document.head.appendChild(scriptEl);
      }
      scriptEl.textContent = JSON.stringify(schema);
    }
  }, [schema]);

  return null;
}